import HelpDeskQuery from 'Query/HelpDesk.query';
import { showNotification } from 'Store/Notification/Notification.action';
import {
    fetchMutation, fetchQuery, getErrorMessage, QueryDispatcher
} from 'Util/Request';

import { setClientTicket, setClientTickets } from './Issue.action';

/** @namespace PeggysagePwa/Store/Issue/Dispatcher */
export class IssueDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    getTickets(dispatch, options = null) {
        return fetchQuery(HelpDeskQuery.getTickets(options)).then(
            /** @namespace PeggysagePwa/Store/Issue/Dispatcher/IssueDispatcher/getTickets/fetchQuery/then */
            (data) => {
                const { customer: { tickets: { items } } } = data;

                // Sort by date descending
                // eslint-disable-next-line no-nested-ternary
                items.sort((a, b) => ((b.created_at > a.created_at) ? 1 : ((a.created_at > b.created_at) ? -1 : 0)));

                dispatch(setClientTickets({ tickets: items }));

                return items;
            },
            /** @namespace PeggysagePwa/Store/Issue/Dispatcher/IssueDispatcher/getTickets/fetchQuery/then/catch */
            (e) => {
                dispatch(showNotification('error', getErrorMessage(e)));
            }
        );
    }

    getTicket(dispatch, id) {
        return fetchQuery(HelpDeskQuery.getTicket(id)).then(
            /** @namespace PeggysagePwa/Store/Issue/Dispatcher/IssueDispatcher/getTicket/fetchQuery/then */
            (data) => {
                const { customer: { ticket } } = data;
                dispatch(setClientTicket({ ticket }));

                return ticket;
            },
            /** @namespace PeggysagePwa/Store/Issue/Dispatcher/IssueDispatcher/getTicket/fetchQuery/then/catch */
            (e) => {
                dispatch(showNotification('error', getErrorMessage(e)));
            }
        );
    }

    async createTicket(dispatch, ticket) {
        try {
            await fetchMutation(HelpDeskQuery.createTicket(ticket));
            // dispatch(setClientTickets({ tickets: items }));
        } catch (e) {
            dispatch(showNotification('error', getErrorMessage(e)));
        }
    }

    async replyToTicket(dispatch, reply) {
        try {
            await fetchMutation(HelpDeskQuery.replyToTicket(reply));
            // dispatch(setClientTickets({ tickets: items }));
        } catch (e) {
            dispatch(showNotification('error', getErrorMessage(e)));
        }
    }
}

export default new IssueDispatcher();
